/** PM Polling — WebSocket-gated AJAX updates, read receipts, member stats.
 *
 * Instead of polling every 6 seconds unconditionally, polls are triggered by
 * WebSocket events (new message, counter update, sync). A 30-second safety-net
 * timer catches anything missed. Falls back to 10-second polling when WebSocket
 * is disconnected.
 */

// Polling mode: 'ws-gated' (default) or 'fallback' (no WebSocket)
var _pollMode = 'ws-gated';
var _safetyNetTimer = null;
var _debouncePollTimer = null;
var _pollInFlight = false;
const SAFETY_NET_INTERVAL = 30000;
const FALLBACK_INTERVAL = 10000;
const DEBOUNCE_DELAY = 500;

window.append_msgs = function(msg_data, target) {
  let msgs_jq = jQuery(msg_data);

  // Collapse messages from same user
  let last_user = $("#threads_right").find(".msg_username:last").text();
  if (last_user === msgs_jq.find(".msg_username:first").text()) {
    msgs_jq.find(".msg_meta_wrapper:first").remove();
    // Show inline actions that were hidden because header was present
    msgs_jq.filter(".pm_msg:first").find(".msg-inline-actions").removeClass("hidden");
    // Tighten spacing for consecutive same-sender messages
    msgs_jq.filter(".pm_msg:first").removeClass("mt-3").addClass("mt-0.5");
  }

  // With column-reverse, scrollTop=0 is the bottom.
  // Check if user is near bottom BEFORE append (scrollHeight changes after).
  var el = document.getElementById('threads_right');
  var wasAtBottom = !el || Math.abs(el.scrollTop) < 80;

  var wrapper = target.find('#messages_wrapper');
  var appendTarget = wrapper.length ? wrapper : target;
  appendTarget.append(msgs_jq);

  // Initialize Lucide icons in the newly appended content
  msgs_jq.each(function() {
    if (window.LucideIcons && this.nodeType === 1) {
      window.LucideIcons.initialize(this);
    }
  });

  // If conversation empty, remove no_messages indicator
  if (target.find(".no_messages").length) {
    target.find(".no_messages").remove();
  }

  // Consolidate read receipt checkmarks
  if (window.consolidateReadReceipts) {
    window.consolidateReadReceipts();
  }

  // With column-reverse, new content at the end of the wrapper appears at
  // the visual bottom. scrollTop=0 keeps us pinned there.
  if (wasAtBottom && el) {
    el.scrollTop = 0;
  }
};

window.update_pm_info_paged = function() {
  if (window.pm_ajax_request_active || _pollInFlight) {
    // Run process again in 1 sec
    window.run_update_process(1000);
    return;
  }
  _pollInFlight = true;

  // If not on first page we dont update threads and messages list
  if (window.get_active_page() != 1) {
    _pollInFlight = false;
    window.run_update_process();
    return;
  }

  let stw = $("#single_thread_wrapper"),
    viewing_thread = stw.length > 0,
    tl = $("#threads_left"),
    options = {
      // TS for user stats
      "ts": window.cur_ts
    };

  if (viewing_thread) {
    // Thread id to get new messages
    options.thread = window.get_active_thread_id();
    // Find newest message
    options.newest_msg_id = window.get_newest_msg_id_in_thread();
  } else {
    // max_msg_id to get thread list changes
    options.max_msg_id = tl.data("max-msg-id");
  }

  $.ajax({
    type: "POST",
    url: "/app/messages/update",
    data: options,
    dataType: "json"
  }).done(function(data, textStatus, jqXHR) {
    if (data?.not_logged_in == 1) {
      window.location.href = window.location.protocol + "//" +
        window.location.hostname + window.location.pathname;
      return;
    }

    // Update member stats if any
    if (typeof data.member_stats != "undefined") {
      window.update_member_stats_messages(data.member_stats);
    }

    let c = $("#conversation");

    if (viewing_thread) {
      // If new messages arrived
      if (typeof data.new_messages != "undefined" && data.new_messages.length > 0) {
        window.messages_highlighted = 1;
        // Remove "new" in 3 seconds
        window.setTimeout(function() {
          window.remove_new_mark();
        }, 3000);

        c.prepend(data.new_messages);
        // If more than 25 msgs - remove
        c.find(".pm_msg:gt(24)").remove();
      }

      // Update "last opened by contact" timestamp
      if (typeof data.lobc != "undefined") {
        /*
         Remove "unread" mark
         Check if timestamp changed
         Microseconds needed
         */
        let l = c.data("lobc");
        // Update only if TS changed
        if (data.lobc > 0 && l < data.lobc) {
          c.data("lobc", data.lobc);
          // Remove unread status and update read receipts
          c.find(".pm_unread").removeClass("pm_unread");
          window.updateReadReceipts();
        }
      }
    } else {
      // If threads list changed
      if (data.threads_update && data.max_msg_id) {
        // Update 'max_msg_id'
        tl.data("max-msg-id", data.max_msg_id);
        tl.empty();
        tl.append(data.threads_update);
      }
    }
  }).always(function() {
    _pollInFlight = false;
    window.run_update_process();
  });
};

window.update_pm_info = function() {
  if (window.pm_ajax_request_active || _pollInFlight) {
    // Run process again in 1 sec
    window.run_update_process(1000);
    return;
  }
  _pollInFlight = true;

  let threadsLeft = $("#threads_left"),
    filtersBlock = $("#filters"),
    filter = filtersBlock.data("filter"),
    newestMsgIdInThread = window.get_newest_msg_id_in_thread();

  $.ajax({
    type: "POST",
    url: "/app/messages/update",
    data: {
      // Send this to get new messages
      "thread": window.get_active_thread_id(),
      // Active filter
      "filter": filter,
      // Find newest message
      "newest_msg_id": newestMsgIdInThread,
      // Send this to get thread list changes
      "max_msg_id": threadsLeft.data("max-msg-id"),
      "threads_count": threadsLeft.find(".pm_thread").length,
      // TS for user stats
      "ts": window.cur_ts
    },
    dataType: "json"
  }).done(function(data, textStatus, jqXHR) {
    // cast as int
    if (data.not_logged_in == 1) {
      window.location.href = window.location.protocol + "//" +
        window.location.hostname + window.location.pathname;
      return;
    }

    // Update member stats if any
    if (typeof data.member_stats != "undefined") {
      window.update_member_stats_messages(data.member_stats);
    }

    // If threads list changed
    if (data.threads_update && data.max_msg_id) {
      // Update 'max_msg_id'
      threadsLeft.data("max-msg-id", data.max_msg_id);

      let activeThreadId = window.get_active_thread_id();
      let savedScrollTop = threadsLeft[0].scrollTop;
      // Parse new content into a fragment, then swap in one operation to avoid blink
      var tmp = document.createElement('div');
      tmp.innerHTML = data.threads_update;
      var frag = document.createDocumentFragment();
      while (tmp.firstChild) frag.appendChild(tmp.firstChild);
      while (threadsLeft[0].firstChild) {
        threadsLeft[0].removeChild(threadsLeft[0].firstChild);
      }
      threadsLeft[0].appendChild(frag);
      threadsLeft[0].scrollTop = savedScrollTop;
      requestAnimationFrame(function() { threadsLeft[0].scrollTop = savedScrollTop; });

      // Initialize Lucide icons in the replaced thread list
      if (window.LucideIcons) {
        window.LucideIcons.initialize(threadsLeft[0]);
      }

      // Re-initialize thread action buttons (desktop dropdown vs mobile swipe)
      if (window.initializeThreadActions) {
        window.initializeThreadActions();
      }

      // Reset infinite scroll state after thread list replacement
      window._threadsFullyLoaded = !document.getElementById('load_more_conversations');

      if (activeThreadId && $("#thread_" + activeThreadId).length) {
        // If threads was reloaded and there was active thread -
        // set active thread again, without reloading messages
        window.view_thread(activeThreadId, false);
        threadsLeft[0].scrollTop = savedScrollTop;
        setTimeout(function() { threadsLeft[0].scrollTop = savedScrollTop; }, 0);
        setTimeout(function() { threadsLeft[0].scrollTop = savedScrollTop; }, 50);
      }
    }

    let activeThreadId1 = window.get_active_thread_id();
    // Update only if thread_id same
    if (typeof data.thread_id == "undefined" || data.thread_id !== activeThreadId1) return;

    // Update "last opened by contact" timestamp
    if (typeof data.lobc != "undefined") {
      window.update_unread(activeThreadId1, data.lobc, data.new_messages.length);
    }

    // Update header status from server response
    if (typeof data.contact_status != "undefined") {
      window.update_header_status(data.contact_status);
    }

    // Hide compose box and update header when the contact is inactive/deleted
    if (data.contact_active === false) {
      $("#threads_right_bottom").addClass("hidden");
      if (data.contact_name) {
        $("#current_thread_username").text(data.contact_name);
      }
    }

    // If new messages arrived
    if (data.new_messages) {
      if (!document.hasFocus() && typeof window.flashTitle === 'function') {
        window.flashTitle('**** ' + window.t('legacy.pm.new_message_alert') + ' ****');
      }

      // In paginated view, skip appending new messages to avoid breaking pagination
      if (window.pagedViewActive) {
        window.run_update_process();
        return;
      }

      window.messages_highlighted = 1;
      // Remove "new" in 3 seconds
      window.setTimeout(function() {
        window.remove_new_mark();
      }, 3000);

      // Find last date divider
      let threadsRight = $("#threads_right"),
        first_datediv = threadsRight.find(".pm_date_div:last");

      // Append new messages to message list
      window.append_msgs(data.new_messages, threadsRight);

      // Remove dup date dividers
      var date = first_datediv.data("date"),
        last_datediv = $("#threads_right").find("div[data-date=" + date + "]:last");
      if (last_datediv.length > 0) {
        last_datediv.remove();
      }

    }
  }).always(function() {
    _pollInFlight = false;
    window.run_update_process();
  });
};

window.remove_new_mark = function() {
  if ($("#single_thread_wrapper").length > 0) {
    // Classic view
    $("#conversation").find(".pm_new").removeClass("pm_new");
  } else {
    // Split view
    $("#threads_right").find(".pm_new").removeClass("pm_new");
  }
};

window.update_unread = function(thread_id, lobc, force_check) {
  let thread = $("#thread_" + thread_id);
  force_check = typeof force_check != "undefined";
  // Check if timestamp changed
  // Microseconds needed
  let l = thread.data("lobc");
  // Update only if TS changed OR force_check = true
  if (force_check || (lobc > 0 && l < lobc)) {
    thread.data("lobc", lobc);
    // Remove unread status and update read receipts
    var $unread = $("#threads_right").find(".pm_unread");
    if ($unread.length) {
      $unread.removeClass("pm_unread");
      window.updateReadReceipts();
    }
  }
};

window.updateReadReceipts = function() {
  // Update unread→read: swap icon and status on wrappers
  document.querySelectorAll("#threads_right .own_msg:not(.pm_unread) .read-receipt-wrap[data-status='unread']").forEach(function(wrap) {
    wrap.setAttribute("data-status", "read");
    var icon = wrap.querySelector("[data-lucide]");
    if (icon) {
      icon.setAttribute("data-lucide", "check-check");
      icon.classList.remove("text-gray-400");
      icon.classList.add("text-sky-400");
    }
    // Re-render the Lucide SVG
    if (window.LucideIcons) {
      window.LucideIcons.initialize(wrap);
    }
  });
  // Re-consolidate after status changes
  window.consolidateReadReceipts();
};

window.consolidateReadReceipts = function() {
  var msgs = document.querySelectorAll("#messages_wrapper > .pm_msg");
  var run = [];
  var lastStatus = null;

  function flushRun() {
    if (run.length === 0) return;
    for (var i = 0; i < run.length - 1; i++) {
      run[i].classList.add("hidden");
      run[i].classList.remove("flex");
    }
    run[run.length - 1].classList.remove("hidden");
    run[run.length - 1].classList.add("flex");
    run = [];
  }

  msgs.forEach(function(msg) {
    var wrap = msg.querySelector(".read-receipt-wrap");
    if (!wrap) {
      flushRun();
      lastStatus = null;
      return;
    }

    var status = wrap.getAttribute("data-status");

    if (lastStatus !== null && lastStatus !== status) {
      flushRun();
    }

    run.push(wrap);
    lastStatus = status;
  });

  flushRun();
};

/**
 * Schedule the next poll. In ws-gated mode, this sets the safety-net timer
 * (30s). In fallback mode (no WebSocket), it polls every 10s.
 * Explicit interval overrides (e.g. retry-in-1s) are honored regardless of mode.
 */
window.run_update_process = function(interval) {
  clearTimeout(_safetyNetTimer);

  if (typeof interval != "undefined") {
    // Explicit interval requested (e.g. retry after busy)
    const updateFn = window.pm_view_mode === "paged" ? window.update_pm_info_paged : window.update_pm_info;
    _safetyNetTimer = window.setTimeout(updateFn, interval);
    return;
  }

  var delay = _pollMode === 'ws-gated' ? SAFETY_NET_INTERVAL : FALLBACK_INTERVAL;
  const updateFn = window.pm_view_mode === "paged" ? window.update_pm_info_paged : window.update_pm_info;
  _safetyNetTimer = window.setTimeout(updateFn, delay);
};

/**
 * Request an immediate poll, debounced to batch rapid WebSocket events.
 * Skipped if a poll is already in flight.
 */
window.requestPoll = function() {
  if (_pollInFlight) return;
  clearTimeout(_debouncePollTimer);
  _debouncePollTimer = setTimeout(function() {
    clearTimeout(_safetyNetTimer);
    const updateFn = window.pm_view_mode === "paged" ? window.update_pm_info_paged : window.update_pm_info;
    updateFn();
  }, DEBOUNCE_DELAY);
};

// WebSocket event listeners — trigger polls on relevant events
document.addEventListener('thread:newmessage', function() {
  window.requestPoll();
});

document.addEventListener('ws:counter-update', function() {
  window.requestPoll();
});

var _wsHasConnectedBefore = false;
document.addEventListener('ws:connected', function() {
  _pollMode = 'ws-gated';
  if (_wsHasConnectedBefore) {
    // Sync state after reconnect (skip on first connect — initial poll handles it)
    window.requestPoll();
  }
  _wsHasConnectedBefore = true;
});

document.addEventListener('ws:disconnected', function() {
  _pollMode = 'fallback';
  // Switch to fallback polling immediately
  window.run_update_process();
});

window.update_member_stats_messages = function(member_stats) {
  // Custom setCount function for messages page that uses raw values
  function setCountRaw(stats, rawId, displayId, msg) {
    var rawValue = stats[rawId] || '';
    var currentValue = parseInt($('#' + displayId).text()) || 0;
    var newValue = parseInt(rawValue) || 0;

    if (currentValue < newValue) {
      // Generate alert if new total is greater than old total.
      window.flashTitle('****  ' + msg + '  ****');
      window.title_flash_type = displayId;
    } else if (rawValue == '' && window.title_flash_type == displayId) {
      window.stopFlashTitle();
    }

    // Display "99+" for counts greater than 99, otherwise show the actual number
    var displayValue = rawValue;
    if (newValue > 99) {
      displayValue = '99+';
    }

    $('#' + displayId).text(displayValue ? '(+' + displayValue + ')' : '');
  }

  // Use raw counts for display elements
  setCountRaw(member_stats, 'pmNewCnt_raw', 'pmNewCnt', 'New Message');
  setCountRaw(member_stats, 'wpNewCnt_raw', 'wpNewCnt', 'New Wall Post');
  setCountRaw(member_stats, 'frNewCnt_raw', 'frNewCnt', 'New Friend Request');
  setCountRaw(member_stats, 'phNewCnt_raw', 'phNewCnt', 'New Photo Comment');
  setCountRaw(member_stats, 'ncNewCnt_raw', 'ncNewCnt', 'New Note Comment');

  if (window.enable_notifs) {
    window.showNotifications(member_stats.msgs);
  }
  window.cur_ts = member_stats.ts;
};
